import { WAC_CROSSFLOW_PARAMS } from '@townsquare/crossflow/wac';
import { homeHeaderViewResource } from '@townsquare/home-header/resources';
import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import { homeTabRoute as homeTabRouteDefinition } from '@townsquare/routes/hometab-view';
import { v2Resource as threadsV2Resource } from '@townsquare/threads/v2-resource';
import { titanEapCrossFlowQueryResource } from '@townsquare/titan-eap-cross-flow/resource';
import { whereYouWorkResource } from '@townsquare/where-you-work/resources';

homeTabRouteDefinition.component = Loadable({
	loader: () => import(/* webpackChunkName: "hometab-view" */ './components/HomeTabView'),
	loading: () => null,
});
homeTabRouteDefinition.resources = [
	titanEapCrossFlowQueryResource,
	homeHeaderViewResource,
	onboardingResource,
	threadsV2Resource,
	whereYouWorkResource,
];
homeTabRouteDefinition.query = [...WAC_CROSSFLOW_PARAMS.map(param => `${param}?`), 'src?', 'cloudId?'];
export const homeTabRoute = homeTabRouteDefinition;
